import { TabNames } from '@/pages-v2/home/storeList/component/StoreTabs/constants'
import VueI18n from '@/i18n/locale'
import { getList, getAreaList } from './service'

// 排除的参数
export const exceptFilterKey = {
  [TabNames.priority.key]: ['notMyStore'],
  [TabNames.area.key]: ['type'],
  [TabNames.my.key]: ['notMyStore'],
  [TabNames.all.key]: ['notMyStore']
}

export const requestTypeMap = {
  [TabNames.priority.key]: 3,
  [TabNames.area.key]: 4,
  [TabNames.my.key]: 2,
  [TabNames.all.key]: 1
}

export const requesterMap = {
  [TabNames.priority.key]: getList,
  [TabNames.area.key]: getAreaList,
  [TabNames.my.key]: getList,
  [TabNames.all.key]: getList
}
export const cityOptionsMap = {
  [TabNames.priority.key]: 'cityIds',
  [TabNames.area.key]: 'areaCityIds',
  [TabNames.my.key]: 'cityIds',
  [TabNames.all.key]: 'cityIds'
}

export const cityValuesMap = {
  [TabNames.priority.key]: ['cityId', 'bdAreaIds'],
  [TabNames.area.key]: ['AreaCityId', 'AreaAreaIds'],
  [TabNames.my.key]: ['cityId', 'bdAreaIds'],
  [TabNames.all.key]: ['cityId', 'bdAreaIds']
}

export const CityAndAreaKeyMap = {
  cityId: 'cityId',
  AreaCityId: 'cityId',
  bdAreaIds: 'bdAreaIds',
  AreaAreaIds: 'bdAreaIds'
}

export const sortTypeEnum = [
  {
    value: 0,
    label: `${VueI18n.t('FoodB_202207_Default_BQmA' /** 默认 */)} (${VueI18n.t(
      'Gattaran_Page_Distance_jPzG' /** 距离 */
    )})`
  },
  {
    value: 4,
    label: `${VueI18n.t('FoodB_0830__wEQD' /** 本月完单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`
  },
  {
    value: 3,
    label: `${VueI18n.t('FoodB_0830__wEQD' /** 本月完单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`
  },
  {
    value: 6,
    label: `${VueI18n.t('FoodB_P0_cNyW_HkyE' /** 完单变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`
  },
  {
    value: 5,
    label: `${VueI18n.t('FoodB_P0_cNyW_HkyE' /** 完单变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`
  },
  {
    value: 8,
    label: `${VueI18n.t(
      'FoodB_V1_raHO_jXSF' /** 本月R burn/GMV */
    )} (${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)}→${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */
    )})`
  },
  {
    value: 7,
    label: `${VueI18n.t(
      'FoodB_V1_raHO_jXSF' /** 本月R burn/GMV */
    )} (${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)}→${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */
    )})`
  },
  {
    value: 10,
    label: `${VueI18n.t(
      'FoodB_V1_zPrX_zWoE' /** R burn/GMV变化量 */
    )} (${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)}→${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */
    )})`
  },
  {
    value: 9,
    label: `${VueI18n.t(
      'FoodB_V1_zPrX_zWoE' /** R burn/GMV变化量 */
    )} (${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)}→${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 低 */
    )})`
  }
]
